import { createSelector, createSlice } from '@reduxjs/toolkit';

const recurrenceRulesSlice = createSlice({
    initialState: {
        rules: [],
        total: 0,
        page: 1,
        pageSize: 25,
        isLoading: false,
        detail: null,
        isDetailLoading: false,
        isDeleting: false,
        filters: [],
    },
    name: 'recurrenceRules',
    reducers: {
        fetchRecurrenceRules: state => {
            state.rules = [];
            // Keep state.total intact during loading so Pagination doesn't
            // briefly think there's only 1 page and clamp activePage back to 1.
            state.isLoading = true;
        },
        modifyRecurrenceRuleFilters: (state, { payload }) => {
            const { data, remove = false } = payload;
            data.forEach(filter => {
                const { key, value } = filter;
                const index = state.filters.findIndex(f => f.key === key);
                if (index === -1 && value === '') return;
                if (remove) {
                    if (index !== -1) state.filters.splice(index, 1);
                    return;
                }
                if (index === -1) {
                    state.filters.push(filter);
                } else {
                    state.filters[index] = filter;
                }
            });
        },
        removeRecurrenceRuleFilter: (state, { payload }) => {
            state.filters = state.filters.filter(f => f.key !== payload);
        },
        clearRecurrenceRuleFilters: state => {
            state.filters = [];
        },
        recurrenceRulesFetched: (state, { payload }) => {
            state.rules = payload.results || [];
            state.total = payload.total || 0;
            state.page = payload.page || 1;
            state.pageSize = payload.pageSize || 25;
            state.isLoading = false;
        },
        recurrenceRulesFetchFailed: state => {
            state.isLoading = false;
        },
        fetchRecurrenceRuleDetail: state => {
            state.detail = null;
            state.isDetailLoading = true;
        },
        recurrenceRuleDetailFetched: (state, { payload }) => {
            state.detail = payload;
            state.isDetailLoading = false;
        },
        recurrenceRuleDetailFetchFailed: state => {
            state.isDetailLoading = false;
        },
        deleteRecurrenceRule: state => {
            state.isDeleting = true;
        },
        recurrenceRuleDeleted: (state, { payload }) => {
            state.isDeleting = false;
            state.rules = state.rules.filter(
                r => r.templateId !== payload.templateId,
            );
            state.total = Math.max(0, state.total - 1);
        },
        recurrenceRuleDeleteFailed: state => {
            state.isDeleting = false;
        },
    },
});

const getSelf = state => state.recurrenceRules;
export const getRecurrenceRules = createSelector(getSelf, s => s.rules);
export const getRecurrenceRulesTotal = createSelector(getSelf, s => s.total);
export const getRecurrenceRulesLoading = createSelector(
    getSelf,
    s => s.isLoading,
);
export const getRecurrenceRuleDetail = createSelector(getSelf, s => s.detail);
export const getRecurrenceRuleDetailLoading = createSelector(
    getSelf,
    s => s.isDetailLoading,
);
export const getRecurrenceRuleDeleting = createSelector(
    getSelf,
    s => s.isDeleting,
);
export const getRecurrenceRuleFilters = createSelector(getSelf, s => s.filters);

export const {
    fetchRecurrenceRules,
    recurrenceRulesFetched,
    recurrenceRulesFetchFailed,
    fetchRecurrenceRuleDetail,
    recurrenceRuleDetailFetched,
    recurrenceRuleDetailFetchFailed,
    deleteRecurrenceRule,
    recurrenceRuleDeleted,
    recurrenceRuleDeleteFailed,
    modifyRecurrenceRuleFilters,
    removeRecurrenceRuleFilter,
    clearRecurrenceRuleFilters,
} = recurrenceRulesSlice.actions;

export default recurrenceRulesSlice.reducer;
